export const FILTER_NAME = 'bucket'
